import { type IAdminFooterLayoutProps } from '@framework/theme/admin/AdminFooterLayout.tsx';
import { FooterContainer } from '../common/footer/FooterContainer.tsx';
import { FrontFooterLayout } from '../front/FrontFooterLayout.tsx';

/**
 * Footer admin.
 */
export function AdminFooterLayout(props: IAdminFooterLayoutProps) {
  return (
    <FooterContainer
      hasSider={props.hasSider}
      hasStaticFooter={props.hasStaticFooter}
    >
      <FrontFooterLayout />
    </FooterContainer>
  );
}
